import { render, staticRenderFns } from "./PlayButton.vue?vue&type=template&id=dead456a&scoped=true&"
import script from "./PlayButton.vue?vue&type=script&lang=js&"
export * from "./PlayButton.vue?vue&type=script&lang=js&"
import style0 from "./PlayButton.vue?vue&type=style&index=0&id=dead456a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dead456a",
  null
  
)

export default component.exports